import { OPS_MANUAL_LINKS, type OpsManualLinkKey } from '../lib/opsManualLinks';

/**
 * 운영 매뉴얼 도움말 링크 — 대상·글은 `lib/opsManualLinks.ts`가 소유한다(여기에 href를 적지 말 것).
 * ⚠️ **새 탭**으로 연다 — 알림 설정처럼 입력 중인 화면에서 같은 탭 이동은 입력 유실이다(Composer 에디터 「📖 매뉴얼」과 같은 이유).
 */
export function OpsManualLink({ topic, className }: { topic: OpsManualLinkKey; className?: string }) {
  const link = OPS_MANUAL_LINKS[topic];
  return (
    <a
      href={link.href}
      target="_blank"
      rel="noreferrer"
      title={`${link.label} (매뉴얼 · 새 탭)`}
      className={className ?? 'text-sm text-brand-600 hover:text-brand-700 hover:underline'}
    >
      📖 {link.label}
    </a>
  );
}
